/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import { Link } from "react-router-dom";
import './Dashboard.css';
import DataTable from "../DataTable";
import L from "../Lang";
import Tick from "../Tick";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { CardPrimary } from "./NewDashboard";

class LabDashboard extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        await this.loadAuditLog();
    }

    loadAuditLog = async () => {
        try {
            const j = await qreq.getAsync('/api/auditlog/list?limit=15');
            if (j.list) {
                this.setState({ auditLog: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    tick = () => {
        this.loadAuditLog();
    }

    render() {
        return <section className="Dashboard dashboard-redesign p-0" aria-label="Laboratory dashboard">
            <Tick interval={5000} onTick={this.tick} />
            <div className="row mt-3">
                <div className="col-12">
                    <CardPrimary title={<L>Activity</L>}>
                        {!this.state.auditLog && <div className="dashboard-widget-state" role="status"><L>Loading activity…</L></div>}
                        {this.state.auditLog?.length === 0 && <div className="dashboard-widget-state"><L>No recent activity.</L></div>}
                        <div className="table-responsive">
                            <DataTable columns={[
                                {
                                    name: 'userFullName', title: 'Who', valueFunc: row => {
                                        if (row.userFullName)
                                            return <Link to={'/user/edit/' + row.userID}>{row.userFullName}</Link>;
                                        return <i><L>System</L></i>;
                                    }
                                },
                                {
                                    name: 'auditType', title: 'Type', valueFunc: row => {
                                        if (row.auditType && row.auditType !== 'General')
                                            return row.auditType;
                                        return <i><L>General</L></i>;
                                    }
                                },
                                {
                                    name: 'message', title: 'Message', valueFunc: row => {
                                        if (row.message) {
                                            if (row.messageLinkPath)
                                                return <Link to={row.messageLinkPath}>{row.message}</Link>
                                            return <span>{row.message}</span>;
                                        }
                                        return <i><L>N/A</L></i>;
                                    }
                                },
                                {
                                    name: 'createdDate', title: 'Date/Time', valueFunc: row => {
                                        if (row.createdDate)
                                            return Globals.toMDYHMLocalDateStringOrDiff(row.createdDate);
                                        return <i><L>N/A</L></i>;
                                    }
                                }
                            ]} data={this.state.auditLog || []} />
                        </div>
                    </CardPrimary>
                </div>
            </div >
        </section>;
    }
}

export default withParamsAndNavigate(LabDashboard);
